module.exports = __webpack_public_path__ + "static/media/eye-icon.f5cb983a.svg";